module.exports = __webpack_public_path__ + "static/resurgences-cc1f92cd1ebf112306883184ae40e217.jpg";